import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ApiRoutes } from 'app/routes/app.routes';
import { HttpService } from '../http/http.service';


@Injectable({
  providedIn: 'root'
})
export class LecturesService {

  private baseUrl = ApiRoutes.api.baseUrl;
  private routes = ApiRoutes.api;
  constructor(private http: HttpClient, private httpService: HttpService) { }

  addLecture(payload: any) {
    return this.httpService.makeRequest({
      path: this.routes.lecture.add,
      method: 'post',
      options: { body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  allLectures(query: any) {
    return this.httpService.makeRequest({
      path: this.routes.lecture.retrieve,
      method: 'get',
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  editLecture(id: string, payload: any) {
    return this.httpService.makeRequest({
      path: this.routes.lecture.edit,
      method: 'put',
      options: { id, body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  deleteLecture(id: string, payload: any) {
    return this.httpService.makeRequest({
      path: this.routes.lecture.delete,
      method: 'delete',
      options: { id },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  bulkDelete(payload: { ids: number[] }) {
    return this.httpService.makeRequest({
      path: this.routes.lecture.delete,
      method: 'delete',
      options: { body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }
}
